import * as React from "react";
import {NumberInput} from "../../../../../widgets/input/number/NumberInput";

interface IBetweenParamProps {
	readonly param: {min: number; max: number};
	onChange(value: {min: number | string; max: number | string}): void;
}

export class BetweenParam extends React.Component<IBetweenParamProps> {
	public override render() {
		const {param, onChange} = this.props;
		const min = param?.min || 0;
		const max = param?.max || 0;

		return (
			<>
				<NumberInput
					value={min}
					onChange={(value) => onChange({min: value, max})}
				/>
				<NumberInput
					value={max}
					onChange={(value) => onChange({min, max: value})}
				/>
			</>
		);
	}
}
